/* eslint-disable import/prefer-default-export */
import { InvoiceStatus } from '../constants/invoiceStatus';

const PAID_STATUSES: string[] = [
    InvoiceStatus.InvoicePayed,
    InvoiceStatus.InvoicePayedErp,
    InvoiceStatus.InvoiceCanceledPaid,
];

const AWAITING_PAYMENT_STATUSES: string[] = [
    InvoiceStatus.BilledWaitingPayment,
    InvoiceStatus.ConfirmingPaymentErp,
];

export function getInvoicePaymentBlockReason(
    status: string | undefined | null,
): string | null {
    if (status === InvoiceStatus.InvoiceApproved) return null;

    if (PAID_STATUSES.includes(status || '')) {
        return 'Este pedido já foi pago.';
    }

    if (AWAITING_PAYMENT_STATUSES.includes(status || '')) {
        return 'Este pedido está aguardando confirmação de pagamento.';
    }

    return 'Este pedido não está aprovado para pagamento.';
}
